module.exports = __webpack_public_path__ + "static/icon-import-9d77428a1fc4013b371b4ef3fd8f3ad8.png";